import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step", "statusLabel", "spinner"]
  
  connect() {
    this.currentStepIndex = 1 // Start at PROCESSING (index 1)
    this.stepNames = ["PENDING", "PROCESSING", "UPLOADING", "EPC SYNCING", "COMPLETED"]
    this.stepDuration = 2500 // 2.5 seconds per step
    
    console.log("Fraud demo status controller connected")
    console.log("Step targets:", this.stepTargets.length)
    
    // Start the progression after a short delay
    setTimeout(() => this.startProgression(), 500)
  }
  
  startProgression() {
    console.log("Starting progression from step:", this.currentStepIndex)
    
    this.progressInterval = setInterval(() => {
      this.currentStepIndex++
      console.log("Moving to step:", this.currentStepIndex)
      
      if (this.currentStepIndex < this.stepNames.length) {
        this.updateStep(this.currentStepIndex)
      } else {
        // All steps completed
        this.completeProgression()
      }
    }, this.stepDuration)
  }
  
  updateStep(stepIndex) {
    console.log("Updating to step:", stepIndex, this.stepNames[stepIndex])
    
    // Update status label
    this.statusLabelTarget.textContent = this.stepNames[stepIndex]
    
    // Update step elements with new class-based approach
    this.stepTargets.forEach((stepElement, index) => {
      // Remove all status classes
      stepElement.classList.remove("completed", "current", "pending")
      
      if (index < stepIndex) {
        // Mark as completed
        stepElement.classList.add("completed")
      } else if (index === stepIndex) {
        // Mark as current
        stepElement.classList.add("current")
      } else {
        // Keep as pending
        stepElement.classList.add("pending")
      }
    })
  }
  
  completeProgression() {
    console.log("Completing progression")
    clearInterval(this.progressInterval)
    
    // Mark final step as completed
    const lastStep = this.stepTargets[this.stepTargets.length - 1]
    lastStep.classList.remove("current", "pending")
    lastStep.classList.add("completed")
    
    // Hide spinner
    this.spinnerTarget.style.display = "none"
    
    // Update status label
    this.statusLabelTarget.textContent = "COMPLETED"
    this.statusLabelTarget.style.color = "#28a745"
    
    // Redirect to sample report after a short delay
    setTimeout(() => {
      console.log("Redirecting to sample report")
      window.location.href = "/fraud-demo/sample"
    }, 1000)
  }
}